module.exports = __webpack_public_path__ + "img/fshop.8204914c.jpg";